import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"

import { supabase } from "@/lib/supabase"
import { getSupabaseFunctionErrorMessage } from "@/utils/supabaseFunctionUtils"

interface CancelOrientationBookingParams {
  bookingId: string
  applicationId: string
  reason?: string
}

export function useCancelOrientationBooking() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ bookingId, reason }: CancelOrientationBookingParams) => {
      const { data, error } = await supabase.functions.invoke("cancel-orientation-booking", {
        body: { bookingId, reason },
      })

      if (error) {
        throw new Error(await getSupabaseFunctionErrorMessage(error))
      }

      if (!data?.success) {
        throw new Error(data?.message || "Failed to cancel orientation booking")
      }

      return data
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["applicationDetails", variables.applicationId],
      })

      toast.success("Orientation Cancelled", {
        description: "The orientation booking has been cancelled.",
      })
    },
    onError: (error) => {
      toast.error("Error", {
        description: error instanceof Error ? error.message : "Failed to cancel booking",
      })
    },
  })
}
